export default __webpack_public_path__ + "static/media/tekton.531cf256.png";